import { render, staticRenderFns } from "./EventParticipations.vue?vue&type=template&id=dd67e978&scoped=true&"
import script from "./EventParticipations.vue?vue&type=script&lang=js&"
export * from "./EventParticipations.vue?vue&type=script&lang=js&"
import style0 from "./EventParticipations.vue?vue&type=style&index=0&id=dd67e978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd67e978",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout,VSpacer})
